
import { useEffect, useState } from 'react'
import sampleFeeds from '../../utils/sampleFeeds';
import cleanText from '../../utils/cleanText';
import { fetchFeed } from '../../api';

function Compete({ setText, index, setUrl, setArrOrigen }) {

    const [arrTitle, setArrTitle] = useState("")
    const [arrUrl, setArrUrl] = useState("")

    const getText = async (u) => {
        let feed = await fetchFeed(u)
        let arrayTitle = []
        let arrayUrl = []
        feed.data.items.forEach(item => {
            arrayTitle.push(cleanText(item.title))
            arrayUrl.push(item.link)
        }); setArrTitle(arrayTitle); setArrUrl(arrayUrl);
    }

    const fateIndex = () => {
        const randomOrigen = Math.floor(Math.random() * sampleFeeds.length)
        getText(sampleFeeds[randomOrigen].value)
        setArrOrigen(sampleFeeds[randomOrigen].label)
    }
    useEffect(() => {
        fateIndex()
    }, [index])

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * arrTitle.length)
        setText(arrTitle[randomIndex])
        setUrl(arrUrl[randomIndex])
    }, [arrTitle, arrUrl])

    return (null)

}

export default Compete
